// Libraries
import React from 'react';

const SyncInventoryFormContext = React.createContext(undefined);

export default SyncInventoryFormContext;
